window.PersonalInformationForm = function(scope) {
    var self = this;
    var formName = "personal-information-form";
    self.name = formName;
    self.status = {completed: true};
    self.selfIdentificationstatus =  {completed: true};

    var _protected = BaseForm.call(self, formName, scope);

    self.load = function() {
        SettingsAPI.loadPersonalInformation()
            .then(function(data) {
                self.phoneStatus = data.phone_status;
                if (data.race_id) {
                    data.race_id += "";
                }

                if (data.veteran_status_id) {
                    data.veteran_status_id += "";
                }

                var hasNotDisclose = data.not_disclose_self_identification_data;
                var hasGender = data.gender;
                var hasRaiceId = data.race_id;
                var hasVeteranStatusId = data.veteran_status_id;

                self.selfIdentificationstatus.completed = hasNotDisclose || ( hasGender && hasRaiceId && hasVeteranStatusId );

                self.data = data;

                setTimeout(function () {
                    self.calculateComplete();
                }, 1000);
            });

    };

    self.save = function() {
        var defer = $q.defer();

        var dataToSend = JSON.parse(JSON.stringify(self.data));
        delete dataToSend.bio;
        delete dataToSend.email;

        SettingsAPI.savePersonalInformation(dataToSend)
            .then(
            function(res) {
                defer.resolve(res);
            },
            function(err) {
                defer.reject(err);
            });

        return defer.promise;
    };

    self.validator.afterValidation(function () {
        setTimeout(function(){
            self.calculateComplete();
        }, 500);
    });

    self.calculateComplete = function () {
        self.status.completed = self.validator.validateWithoutError();

        var hasNotDisclose = self.data.not_disclose_self_identification_data;
        var hasGender = self.data.gender;
        var hasRaiceId = self.data.race_id;
        var hasVeteranStatusId = self.data.veteran_status_id;


        self.selfIdentificationstatus.completed = hasNotDisclose || ( hasGender && hasRaiceId && hasVeteranStatusId );

        if (scope) {
            try {
                scope.$digest();
            }
            catch (e) { /* Do Nothing */ }
        }
        else {
            console.warn("Scope is not here: form name: ", name);
        }
    }

    self.load();
}
